import { render, staticRenderFns } from "./maixiang.vue?vue&type=template&id=35bbc13d&"
import script from "./maixiang.vue?vue&type=script&lang=ts&"
export * from "./maixiang.vue?vue&type=script&lang=ts&"
import style0 from "./maixiang.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports